import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { IconWrapper, SvgIcon } from '../../Icon';
import KubitTooltip from '../../KubitTooltip';

interface IProps {
  dictionaryUrl: string;
}

const StyledIconWrapper = styled(IconWrapper)``;

const GoToDictionaryAction = ({ dictionaryUrl }: IProps) => (
  <KubitTooltip content={'Go to Dictionary'} placement="top">
    <StyledIconWrapper forwardedAs={Link} to={dictionaryUrl} size={16}>
      <SvgIcon
        name="book-open-text"
        width={16}
        height={16}
        isHoverable={true}
      />
    </StyledIconWrapper>
  </KubitTooltip>
);

export default GoToDictionaryAction;
